declare namespace $ {

	type $bog_vmap_app_pane_field__style_bog_vmap_app_pane_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['field_style'] >
		,
		ReturnType< $bog_vmap_app_pane_field['style'] >
	>
	type $bog_vmap_app_pane_field__sub_bog_vmap_app_pane_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['field_sub'] >
		,
		ReturnType< $bog_vmap_app_pane_field['sub'] >
	>
	type $bog_vmap_app_pane_field__camera_shift_bog_vmap_app_pane_3 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['camera_shift'] >
		,
		ReturnType< $bog_vmap_app_pane_field['camera_shift'] >
	>
	type $bog_vmap_app_pane_field__camera_zoom_bog_vmap_app_pane_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['camera_zoom'] >
		,
		ReturnType< $bog_vmap_app_pane_field['camera_zoom'] >
	>
	type $mol_vector_2d__bog_vmap_app_pane_5 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	type $bog_vmap_app_pane_frame__html_bog_vmap_app_pane_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['scene_html'] >
		,
		ReturnType< $bog_vmap_app_pane_frame['html'] >
	>
	type $bog_vmap_app_pane_overlay__style_bog_vmap_app_pane_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['overlay_style'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['style'] >
	>
	type $bog_vmap_app_pane_overlay__frames_bog_vmap_app_pane_8 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['frames'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['frames'] >
	>
	type $bog_vmap_app_pane_overlay__frame_style_bog_vmap_app_pane_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['frame_style'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['frame_style'] >
	>
	type $bog_vmap_app_pane_overlay__inner_bog_vmap_app_pane_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['inner_shown'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['inner'] >
	>
	type $bog_vmap_app_pane_overlay__inner_style_bog_vmap_app_pane_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['inner_style'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['inner_style'] >
	>
	type $bog_vmap_app_pane_overlay__press_bog_vmap_app_pane_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_press'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['press'] >
	>
	type $bog_vmap_app_pane_overlay__move_bog_vmap_app_pane_13 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_move'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['move'] >
	>
	type $bog_vmap_app_pane_overlay__release_bog_vmap_app_pane_14 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_release'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['release'] >
	>
	type $bog_vmap_app_pane_overlay__lost_bog_vmap_app_pane_15 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_lost'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['lost'] >
	>
	type $bog_vmap_app_pane_overlay__away_bog_vmap_app_pane_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_away'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['away'] >
	>
	type $bog_vmap_app_pane_overlay__context_bog_vmap_app_pane_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_context'] >
		,
		ReturnType< $bog_vmap_app_pane_overlay['context'] >
	>
	type $bog_vmap_app_wire__lines_bog_vmap_app_pane_18 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['wire_lines'] >
		,
		ReturnType< $bog_vmap_app_wire['lines'] >
	>
	type $bog_vmap_app_wire__dots_bog_vmap_app_pane_19 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['wire_dots'] >
		,
		ReturnType< $bog_vmap_app_wire['dots'] >
	>
	type $bog_vmap_app_wire__drag_geometry_bog_vmap_app_pane_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['wire_drag_geometry'] >
		,
		ReturnType< $bog_vmap_app_wire['drag_geometry'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_21 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['value_labels'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['name_views'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_23 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['error_marks'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $bog_vmap_app_pane_label__style_bog_vmap_app_pane_24 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['label_style'] >
		,
		ReturnType< $bog_vmap_app_pane_label['style'] >
	>
	type $bog_vmap_app_pane_label__lines_bog_vmap_app_pane_25 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['label_lines'] >
		,
		ReturnType< $bog_vmap_app_pane_label['lines'] >
	>
	type $mol_view__style_bog_vmap_app_pane_26 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['name_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__attr_bog_vmap_app_pane_27 = $mol_type_enforce<
		({ 
			'bog_vmap_app_pane_name_picked': ReturnType< $bog_vmap_app_pane['name_picked'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_bog_vmap_app_pane_28 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $bog_vmap_app_pane['name_press'] > ): ReturnType< $bog_vmap_app_pane['name_press'] >,
			dblclick( next?: ReturnType< $bog_vmap_app_pane['name_edit'] > ): ReturnType< $bog_vmap_app_pane['name_edit'] >,
		})  & ReturnType< $mol_view['event'] >
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_29 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__style_bog_vmap_app_pane_30 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['name_style'] >
		,
		ReturnType< $mol_string['style'] >
	>
	type $mol_string__hint_bog_vmap_app_pane_31 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_pane_32 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['name_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_vmap_app_pane_33 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['name_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_bog_vmap_app_pane_34 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $bog_vmap_app_pane['name_submit'] > ): ReturnType< $bog_vmap_app_pane['name_submit'] >,
			keydown( next?: ReturnType< $bog_vmap_app_pane['name_key'] > ): ReturnType< $bog_vmap_app_pane['name_key'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_view__style_bog_vmap_app_pane_35 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['mark_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__attr_bog_vmap_app_pane_36 = $mol_type_enforce<
		({ 
			'title': ReturnType< $bog_vmap_app_pane['mark_hint'] >,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_37 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_vmap_app_pane_38 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['insert_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_bog_vmap_app_pane_39 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['sizing_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_40 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_string__style_bog_vmap_app_pane_41 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['text_new_style'] >
		,
		ReturnType< $mol_string['style'] >
	>
	type $mol_string__hint_bog_vmap_app_pane_42 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_pane_43 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['text_new'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_vmap_app_pane_44 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['text_new_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_bog_vmap_app_pane_45 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $bog_vmap_app_pane['text_new_submit'] > ): ReturnType< $bog_vmap_app_pane['text_new_submit'] >,
			keydown( next?: ReturnType< $bog_vmap_app_pane['text_new_key'] > ): ReturnType< $bog_vmap_app_pane['text_new_key'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_string__style_bog_vmap_app_pane_46 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['text_style'] >
		,
		ReturnType< $mol_string['style'] >
	>
	type $mol_string__hint_bog_vmap_app_pane_47 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_pane_48 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['text_draft'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__submit_bog_vmap_app_pane_49 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['text_submit'] >
		,
		ReturnType< $mol_string['submit'] >
	>
	type $mol_string__event_bog_vmap_app_pane_50 = $mol_type_enforce<
		({ 
			blur( next?: ReturnType< $bog_vmap_app_pane['text_submit'] > ): ReturnType< $bog_vmap_app_pane['text_submit'] >,
			keydown( next?: ReturnType< $bog_vmap_app_pane['text_key'] > ): ReturnType< $bog_vmap_app_pane['text_key'] >,
		})  & ReturnType< $mol_string['event'] >
		,
		ReturnType< $mol_string['event'] >
	>
	type $mol_view__style_bog_vmap_app_pane_51 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['say_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_52 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_vmap_app_pane_53 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['band_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_bog_vmap_app_pane_54 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['draft_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_bog_vmap_app_pane_55 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['snap_hint_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_bog_vmap_app_pane_56 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['guide_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__attr_bog_vmap_app_pane_57 = $mol_type_enforce<
		({ 
			'bog_vmap_app_pane_guide_picked': ReturnType< $bog_vmap_app_pane['guide_picked'] >,
			'bog_vmap_app_pane_guide_axis': ReturnType< $bog_vmap_app_pane['guide_axis'] >,
			'title': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_bog_vmap_app_pane_58 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_vmap_app_pane['guide_press'] > ): ReturnType< $bog_vmap_app_pane['guide_press'] >,
			pointermove( next?: ReturnType< $bog_vmap_app_pane['guide_move'] > ): ReturnType< $bog_vmap_app_pane['guide_move'] >,
			pointerup( next?: ReturnType< $bog_vmap_app_pane['guide_release'] > ): ReturnType< $bog_vmap_app_pane['guide_release'] >,
		})  & ReturnType< $mol_view['event'] >
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__style_bog_vmap_app_pane_59 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['gap_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_60 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_vmap_app_pane_61 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['ruler_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_62 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['ruler_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__attr_bog_vmap_app_pane_63 = $mol_type_enforce<
		({ 
			'title': string,
		})  & ReturnType< $mol_view['attr'] >
		,
		ReturnType< $mol_view['attr'] >
	>
	type $mol_view__event_bog_vmap_app_pane_64 = $mol_type_enforce<
		({ 
			pointerdown( next?: ReturnType< $bog_vmap_app_pane['ruler_press'] > ): ReturnType< $bog_vmap_app_pane['ruler_press'] >,
			pointermove( next?: ReturnType< $bog_vmap_app_pane['guide_move'] > ): ReturnType< $bog_vmap_app_pane['guide_move'] >,
			pointerup( next?: ReturnType< $bog_vmap_app_pane['guide_release'] > ): ReturnType< $bog_vmap_app_pane['guide_release'] >,
		})  & ReturnType< $mol_view['event'] >
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__style_bog_vmap_app_pane_65 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['tick_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_66 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_vmap_app_pane_67 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['span_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__style_bog_vmap_app_pane_68 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['ghost_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $bog_vmap_app_menu__showed_bog_vmap_app_pane_69 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['menu_showed'] >
		,
		ReturnType< $bog_vmap_app_menu['showed'] >
	>
	type $bog_vmap_app_menu__left_bog_vmap_app_pane_70 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['menu_left'] >
		,
		ReturnType< $bog_vmap_app_menu['left'] >
	>
	type $bog_vmap_app_menu__top_bog_vmap_app_pane_71 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['menu_top'] >
		,
		ReturnType< $bog_vmap_app_menu['top'] >
	>
	type $bog_vmap_app_menu__on_node_bog_vmap_app_pane_72 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['menu_on_node'] >
		,
		ReturnType< $bog_vmap_app_menu['on_node'] >
	>
	type $bog_vmap_app_menu__editable_bog_vmap_app_pane_73 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['editable'] >
		,
		ReturnType< $bog_vmap_app_menu['editable'] >
	>
	type $bog_vmap_app_menu__copy_bog_vmap_app_pane_74 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_copy'] >
		,
		ReturnType< $bog_vmap_app_menu['copy'] >
	>
	type $bog_vmap_app_menu__remove_bog_vmap_app_pane_75 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_delete'] >
		,
		ReturnType< $bog_vmap_app_menu['remove'] >
	>
	type $bog_vmap_app_menu__wrap_bog_vmap_app_pane_76 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_wrap'] >
		,
		ReturnType< $bog_vmap_app_menu['wrap'] >
	>
	type $bog_vmap_app_menu__group_bog_vmap_app_pane_77 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_group'] >
		,
		ReturnType< $bog_vmap_app_menu['group'] >
	>
	type $bog_vmap_app_menu__ungroup_bog_vmap_app_pane_78 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_ungroup'] >
		,
		ReturnType< $bog_vmap_app_menu['ungroup'] >
	>
	type $bog_vmap_app_menu__ungroup_enabled_bog_vmap_app_pane_79 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['ungroup_enabled'] >
		,
		ReturnType< $bog_vmap_app_menu['ungroup_enabled'] >
	>
	type $bog_vmap_app_menu__reset_bog_vmap_app_pane_80 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['node_reset_all'] >
		,
		ReturnType< $bog_vmap_app_menu['reset'] >
	>
	type $bog_vmap_app_menu__reset_enabled_bog_vmap_app_pane_81 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['reset_enabled'] >
		,
		ReturnType< $bog_vmap_app_menu['reset_enabled'] >
	>
	type $bog_vmap_app_menu__parent_bog_vmap_app_pane_82 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['menu_parent'] >
		,
		ReturnType< $bog_vmap_app_menu['parent'] >
	>
	type $bog_vmap_app_menu__parent_enabled_bog_vmap_app_pane_83 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['menu_parent_enabled'] >
		,
		ReturnType< $bog_vmap_app_menu['parent_enabled'] >
	>
	type $bog_vmap_app_menu__enter_bog_vmap_app_pane_84 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['menu_enter'] >
		,
		ReturnType< $bog_vmap_app_menu['enter'] >
	>
	type $bog_vmap_app_menu__board_bog_vmap_app_pane_85 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['menu_board'] >
		,
		ReturnType< $bog_vmap_app_menu['board'] >
	>
	type $bog_vmap_app_menu__fit_bog_vmap_app_pane_86 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane['camera_reset'] >
		,
		ReturnType< $bog_vmap_app_menu['fit'] >
	>
	export class $bog_vmap_app_pane extends $mol_view {
		file_over( next?: any ): any
		file_take( next?: any ): any
		field_style( ): Record<string, any>
		field_sub( ): readonly($mol_view)[]
		Field( ): $bog_vmap_app_pane_field
		overlay_style( ): Record<string, any>
		frames( ): readonly(string)[]
		frame_style( id: any): Record<string, any>
		inner_shown( ): string
		inner_style( ): Record<string, any>
		node_press( next?: any ): any
		node_move( next?: any ): any
		node_release( next?: any ): any
		node_lost( next?: any ): any
		node_away( next?: any ): any
		node_context( next?: any ): any
		wire_lines( ): readonly($bog_vmap_app_wire_line)[]
		wire_dots( ): readonly($bog_vmap_app_wire_dot)[]
		wire_drag_geometry( ): string
		value_labels( ): readonly($mol_view)[]
		name_views( ): readonly($mol_view)[]
		error_marks( ): readonly($mol_view)[]
		label_style( id: any): Record<string, any>
		label_lines( id: any): readonly(string)[]
		name_style( id: any): Record<string, any>
		name_picked( id: any): boolean
		name_press( id: any, next?: any ): any
		name_edit( id: any, next?: any ): any
		name_title( id: any): string
		name_draft( id: any, next?: string ): string
		name_submit( id: any, next?: any ): any
		name_key( id: any, next?: any ): any
		mark_style( id: any): Record<string, any>
		mark_hint( id: any): string
		insert_style( ): Record<string, any>
		sizing_style( ): Record<string, any>
		sizing_note( ): string
		text_new_style( ): Record<string, any>
		text_new( next?: string ): string
		text_new_submit( next?: any ): any
		text_new_key( next?: any ): any
		text_style( id: any): Record<string, any>
		text_draft( id: any, next?: string ): string
		text_submit( id: any, next?: any ): any
		text_key( id: any, next?: any ): any
		say_style( ): Record<string, any>
		say_note( ): string
		band_style( ): Record<string, any>
		draft_style( ): Record<string, any>
		snap_hint_style( id: any): Record<string, any>
		guide_style( id: any): Record<string, any>
		guide_picked( id: any): boolean
		guide_axis( id: any): string
		guide_press( id: any, next?: any ): any
		guide_move( id: any, next?: any ): any
		guide_release( id: any, next?: any ): any
		gap_style( id: any): Record<string, any>
		gap_title( id: any): string
		ruler_style( id: any): Record<string, any>
		ruler_sub( id: any): readonly($mol_view)[]
		ruler_press( id: any, next?: any ): any
		tick_style( id: any): Record<string, any>
		tick_title( id: any): string
		span_style( id: any): Record<string, any>
		ghost_style( id: any): Record<string, any>
		menu_showed( next?: boolean ): boolean
		menu_left( ): string
		menu_top( ): string
		menu_on_node( ): boolean
		menu_parent( next?: any ): any
		menu_parent_enabled( ): boolean
		menu_enter( next?: any ): any
		menu_board( next?: any ): any
		attr( ): ({ 
			'tabindex': string,
			'bog_vmap_app_pane_tool': ReturnType< $bog_vmap_app_pane['tool'] >,
			'bog_vmap_app_pane_hand': ReturnType< $bog_vmap_app_pane['hand'] >,
		})  & ReturnType< $mol_view['attr'] >
		tool( next?: string ): string
		grip( next?: boolean ): boolean
		hand( ): boolean
		tool_select( next?: boolean ): boolean
		tool_board( next?: boolean ): boolean
		tool_text( next?: boolean ): boolean
		tool_hand( next?: boolean ): boolean
		editable( ): boolean
		board_draw( next?: any ): any
		text_draw( next?: any ): any
		text_enabled( ): boolean
		node_resize( next?: any ): any
		node_text( id: any): string
		node_text_kind( id: any): string
		node_text_write( next?: any ): any
		node_delete( next?: any ): any
		node_copy( next?: any ): any
		node_wrap( next?: any ): any
		node_group( next?: any ): any
		node_ungroup( next?: any ): any
		ungroup_enabled( ): boolean
		node_reset_all( next?: any ): any
		reset_enabled( ): boolean
		node_clone( next?: any ): any
		leave( next?: any ): any
		key_down( id: any): boolean
		key_up( id: any): any
		scene_bundle( ): string
		scene_html( ): string
		pack_uri( ): string
		theme( ): string
		doc_src( ): string
		doc_css( ): string
		spots( next?: Record<string, any> ): Record<string, any>
		guides( next?: Record<string, any> ): Record<string, any>
		picked( next?: readonly(string)[] ): readonly(string)[]
		inner( ): string
		doc_js( ): Record<string, any>
		doc_root( ): string
		libs( ): readonly($bog_vmap_bridge_part)[]
		carrying( ): boolean
		wires( ): readonly($bog_vmap_lang_link)[]
		part_ports( id: any): readonly($bog_vmap_app_wire_port)[]
		part_overs( id: any): readonly(string)[]
		link_add( next?: any ): any
		link_drop( next?: any ): any
		containers( ): readonly(string)[]
		doc_names( ): readonly(string)[]
		doc_paths( ): readonly(string)[]
		doc_key( ): string
		node_title( next?: string ): string
		axis( id: any): string
		tree_move( next?: any ): any
		carry_at( next?: any ): any
		carry_drop( next?: any ): any
		files_drop( next?: any ): any
		event( ): ({ 
			dragover( next?: ReturnType< $bog_vmap_app_pane['file_over'] > ): ReturnType< $bog_vmap_app_pane['file_over'] >,
			drop( next?: ReturnType< $bog_vmap_app_pane['file_take'] > ): ReturnType< $bog_vmap_app_pane['file_take'] >,
		})  & ReturnType< $mol_view['event'] >
		values( next?: Record<string, any> ): Record<string, any>
		handshake( id: any, next?: number ): number
		ready( ): boolean
		stalled( next?: boolean ): boolean
		warmed( next?: boolean ): boolean
		entered( next?: any ): any
		inside( ): boolean
		world_center( ): readonly(number)[]
		free_spot( ): readonly(number)[]
		key_field( id: any): boolean
		part_size( id: any): any
		copy_spot( id: any): any
		camera_fit( next?: any ): any
		camera_reset( next?: any ): any
		node_show( next?: any ): any
		zoom_out( next?: any ): any
		zoom_in( next?: any ): any
		zoom_full( next?: any ): any
		zoom_title( ): string
		node_error( id: any): string
		scene_restart( next?: any ): any
		error_at( id: any, next?: string ): string
		error_node( id: any, next?: string ): string
		pack_note( ): string
		scene_lost( next?: string ): string
		error( ): string
		isolation( ): string
		camera_shift( next?: $mol_vector_2d<number> ): $mol_vector_2d<number>
		camera_zoom( next?: number ): number
		scene_generation( next?: number ): number
		Scene( id: any): $bog_vmap_app_pane_frame
		sub( ): readonly(any)[]
		Overlay( ): $bog_vmap_app_pane_overlay
		Wire( ): $bog_vmap_app_wire
		Values( ): $mol_view
		Names( ): $mol_view
		Marks( ): $mol_view
		Label( id: any): $bog_vmap_app_pane_label
		Name( id: any): $mol_view
		Name_field( id: any): $mol_string
		Mark( id: any): $mol_view
		Insert( ): $mol_view
		Sizing( ): $mol_view
		Text_new( ): $mol_string
		Text_field( id: any): $mol_string
		Say( ): $mol_view
		Band( ): $mol_view
		Draft( ): $mol_view
		Snap_hint( id: any): $mol_view
		Guide( id: any): $mol_view
		Gap( id: any): $mol_view
		Ruler( id: any): $mol_view
		Tick( id: any): $mol_view
		Span( id: any): $mol_view
		Ghost( id: any): $mol_view
		Menu( id: any): $bog_vmap_app_menu
	}
	
	type $mol_touch__allow_draw_bog_vmap_app_pane_field_1 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_touch['allow_draw'] >
	>
	type $mol_touch__allow_pan_bog_vmap_app_pane_field_2 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_touch['allow_pan'] >
	>
	type $mol_touch__allow_zoom_bog_vmap_app_pane_field_3 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_touch['allow_zoom'] >
	>
	type $mol_touch__pan_bog_vmap_app_pane_field_4 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane_field['camera_shift'] >
		,
		ReturnType< $mol_touch['pan'] >
	>
	type $mol_touch__zoom_bog_vmap_app_pane_field_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane_field['camera_zoom'] >
		,
		ReturnType< $mol_touch['zoom'] >
	>
	type $mol_vector_2d__bog_vmap_app_pane_field_6 = $mol_type_enforce<
		[ number, number ]
		,
		ConstructorParameters< typeof $mol_vector_2d<number> >
	>
	export class $bog_vmap_app_pane_field extends $mol_view {
		Touch( ): $mol_touch
		camera_shift( next?: $mol_vector_2d<number> ): $mol_vector_2d<number>
		camera_zoom( next?: number ): number
		plugins( ): readonly(any)[]
	}
	
	type $bog_vmap_app_pane_handle__corner_bog_vmap_app_pane_overlay_1 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_pane_handle['corner'] >
	>
	type $bog_vmap_app_pane_handle__corner_bog_vmap_app_pane_overlay_2 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_pane_handle['corner'] >
	>
	type $bog_vmap_app_pane_handle__corner_bog_vmap_app_pane_overlay_3 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_pane_handle['corner'] >
	>
	type $bog_vmap_app_pane_handle__corner_bog_vmap_app_pane_overlay_4 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_pane_handle['corner'] >
	>
	type $bog_vmap_app_pane_handle__corner_bog_vmap_app_pane_overlay_5 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_pane_handle['corner'] >
	>
	type $bog_vmap_app_pane_handle__corner_bog_vmap_app_pane_overlay_6 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_pane_handle['corner'] >
	>
	type $bog_vmap_app_pane_handle__corner_bog_vmap_app_pane_overlay_7 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_pane_handle['corner'] >
	>
	type $bog_vmap_app_pane_handle__corner_bog_vmap_app_pane_overlay_8 = $mol_type_enforce<
		string
		,
		ReturnType< $bog_vmap_app_pane_handle['corner'] >
	>
	type $mol_view__style_bog_vmap_app_pane_overlay_9 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane_overlay['frame_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_overlay_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__style_bog_vmap_app_pane_overlay_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane_overlay['inner_style'] >
		,
		ReturnType< $mol_view['style'] >
	>
	export class $bog_vmap_app_pane_overlay extends $mol_view {
		press( next?: any ): any
		move( next?: any ): any
		release( next?: any ): any
		lost( next?: any ): any
		away( next?: any ): any
		context( next?: any ): any
		frame_style( id: any): Record<string, any>
		Handle_nw( ): $bog_vmap_app_pane_handle
		Handle_n( ): $bog_vmap_app_pane_handle
		Handle_ne( ): $bog_vmap_app_pane_handle
		Handle_e( ): $bog_vmap_app_pane_handle
		Handle_se( ): $bog_vmap_app_pane_handle
		Handle_s( ): $bog_vmap_app_pane_handle
		Handle_sw( ): $bog_vmap_app_pane_handle
		Handle_w( ): $bog_vmap_app_pane_handle
		inner_style( ): Record<string, any>
		frames( ): readonly(string)[]
		inner( ): string
		event( ): ({ 
			pointerdown( next?: ReturnType< $bog_vmap_app_pane_overlay['press'] > ): ReturnType< $bog_vmap_app_pane_overlay['press'] >,
			pointermove( next?: ReturnType< $bog_vmap_app_pane_overlay['move'] > ): ReturnType< $bog_vmap_app_pane_overlay['move'] >,
			pointerup( next?: ReturnType< $bog_vmap_app_pane_overlay['release'] > ): ReturnType< $bog_vmap_app_pane_overlay['release'] >,
			pointercancel( next?: ReturnType< $bog_vmap_app_pane_overlay['release'] > ): ReturnType< $bog_vmap_app_pane_overlay['release'] >,
			lostpointercapture( next?: ReturnType< $bog_vmap_app_pane_overlay['lost'] > ): ReturnType< $bog_vmap_app_pane_overlay['lost'] >,
			pointerleave( next?: ReturnType< $bog_vmap_app_pane_overlay['away'] > ): ReturnType< $bog_vmap_app_pane_overlay['away'] >,
			contextmenu( next?: ReturnType< $bog_vmap_app_pane_overlay['context'] > ): ReturnType< $bog_vmap_app_pane_overlay['context'] >,
		})  & ReturnType< $mol_view['event'] >
		Frame( id: any): $mol_view
		Inner( ): $mol_view
	}
	
	type $mol_view__sub_bog_vmap_app_pane_label_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_pane_label['row_cells'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_bog_vmap_app_pane_label_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_vmap_app_pane_label extends $mol_view {
		rows( ): readonly($mol_view)[]
		row_cells( id: any): readonly($mol_view)[]
		cell_text( id: any): string
		lines( ): readonly(string)[]
		sub( ): ReturnType< $bog_vmap_app_pane_label['rows'] >
		Row( id: any): $mol_view
		Cell( id: any): $mol_view
	}
	
	export class $bog_vmap_app_pane_handle extends $mol_view {
		corner( ): string
		attr( ): ({ 
			'bog_vmap_app_pane_handle_corner': ReturnType< $bog_vmap_app_pane_handle['corner'] >,
		})  & ReturnType< $mol_view['attr'] >
	}
	
	export class $bog_vmap_app_pane_frame extends $mol_frame {
		attr( ): ({ 
			'sandbox': string,
			'src': any,
		})  & ReturnType< $mol_frame['attr'] >
	}
	
}

//# sourceMappingURL=pane.view.tree.d.ts.map